<template>
  <section class="content-block">
    <transition name="slide-fade">
      <div
        v-if="active && content"
        class="block has-white-background"
      >
        <router-link
          to="/"
          class="back "
        >
          {{ "< " + $t('back') }}
        </router-link>
        <div
          v-if="content.text"
          class="content-block-inner"
          v-html="content.text"
        />
        <router-link
          to="/"
          class="back button is-primary has-icons-right"
        >
          {{ $t('back') }}
          <i class="arrow left" />
        </router-link>
      </div>
    </transition>
  </section>
</template>

<script>

export default {
  name: 'InctContent',
  props: {
    content: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      active: false,
    }
  },
  mounted() {
    this.active = true;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.back {
  display: inline-block;
  margin-bottom: 20px;

  &.button {
    margin: 2em auto 0;
    display: flex;
  }

  &:not(.button):hover {
    color: #3273dc;
  }
}
</style>
